import { ReactComponent as IconClosedFolder } from '@/assets/svgs/closed-folder.svg'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconRootFolder } from '@/assets/svgs/root-folder.svg'
import { ReactComponent as IconRotatedPin } from '@/assets/svgs/rotated-pin.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import useFolders from '@/hooks/use-folder/index'
import { useLocation, useParams } from '@/lib/router-dom'
import rem from '@/utils/rem'
import React, { useEffect } from 'react'

function MoveFolderModal({ visible, close, id, eclipFolderId }) {
	const [selected, setSelected] = React.useState(null)
	const { currentPath } = useLocation()

	const { type } = useParams()

	const { items: folders, fetch: getFolders, create, update } = useFolders()

	const init = async () => {
		const type = currentPath.includes('shared') ? 'RECEIVE' : 'SEND'
		getFolders({ type })
	}

	useEffect(() => {
		if (visible) {
			init()
		}
	}, [visible])

	const createNewFolder = async (name) => {
		const type = currentPath.includes('shared') ? 'RECEIVE' : 'SEND'
		await create(type, {
			folderName: name,
		})
		init()
		document.getElementById('reload-eclips')?.click()
		// close()
	}

	const handleSubmit = async () => {
		if (selected || selected === null) {
			await update(id, { folderId: selected })

			document.getElementById('reload-eclips')?.click()
		}
		close()
	}

	const ListFolders = () => {
		return (
			<div>
				{(eclipFolderId ? [
					{
						id: null,
						name: `Move to ${
						(currentPath.includes('shared') || type === 'RECEIVE') ? 'Shared with me' : 'My Packages'
						}`,
					},
					...folders,
				]
				: folders
				)?.map((item, index) => {
					return (
						<div
							key={index}
							className={
								'eclip-landing__move-model--wrapper' +
								(selected === item.id ? ' selected' : '')
							}
							onClick={() => setSelected(item.id)}
						>
							{item.id === null ? <IconRootFolder /> : <IconClosedFolder />}

							<span
								className={
								'eclip-landing__move-modal--label' +
								(selected === item.id ? ' selected' : '')
								}
							>
								{item.name || 'Untitled Folder'}
							</span>
						</div>
					)
				})}
			</div>
		)
	}

	return (
		<Modal visible={visible} variant='medium' close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconRotatedPin />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										<span>Move</span>
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="eclip-move-modal__title">
						<span>Select folder to move Package</span>
						<Button
							noborder
							text={'+ Create New Folder'}
							submit={() => {
							createNewFolder('Untitled Folder')
							}}
						/>
						</div>
						<div
						style={{
							height: rem(247),
							overflowY: 'auto',
							maxHeight: rem(247),
						}}
						>
						<ListFolders />
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Ok"
							submit={() => {
								handleSubmit()
								// close(selected)
							}}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}

export default MoveFolderModal
